

















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import OrderEmergensiForm from "./OrderEmergensiForm.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import OrderEmergensiSvc from "@/services/OrderEmergensi";
import { storeOrderEmergensi } from "@/store/modules/OrderEmergensiStore";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { OrderEmergensi, PaketObatEmergensi } from "@/types/order_emergensi";
import { ALASAN_READ_ONLY, STATUS_ORDER_EMERGENSI } from "./orderEmergensi.config";

@Component({
  components: { OrderEmergensiForm, CardModalTtd },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class OrderEmergensiList extends Vue {
  @Prop({ required: true }) register!: string;
  @Prop() rm!: string;
  @Prop({ type: String, default: "ranap" }) konteks!: string;
  @Prop({ default: null }) focusOrderId!: number | null;

  isReadOnly!: () => boolean;

  formTerbuka = false;
  fokusTertunda: number | null = null;
  formKey = 0;
  modeLihat = false;
  paketDipilih: PaketObatEmergensi | null = null;
  orderDipilih: OrderEmergensi | null = null;

  dialogBatal = false;
  alasanBatalInput = "";
  membatalkan = false;
  dialogTtd = false;
  menandatangani = false;
  orderAksi: OrderEmergensi | null = null;

  headers = [
    { text: "Waktu Order", value: "ordered_at", width: "130px", sortable: false },
    { text: "Paket / Indikasi", value: "paket_nama", sortable: false },
    { text: "Dokter", value: "dokter", sortable: false },
    { text: "Depo", value: "depo", sortable: false },
    { text: "No. Resep", value: "resep", width: "120px", sortable: false },
    { text: "Status", value: "status", width: "170px", sortable: false },
    { text: "TTD", value: "signed", width: "70px", sortable: false },
    { text: "Aksi", value: "actions", width: "190px", sortable: false }
  ];

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get list(): OrderEmergensi[] {
    return storeOrderEmergensi.registerId === String(this.register) ? storeOrderEmergensi.list : [];
  }

  get loading(): boolean {
    return storeOrderEmergensi.loading;
  }

  get paketAktif(): PaketObatEmergensi[] {
    return storeOrderEmergensi.paketAktif;
  }

  get loadingPaket(): boolean {
    return storeOrderEmergensi.loadingPaket;
  }

  get alasanTidakBisaOrder(): string | null {
    if (this.readOnly) return ALASAN_READ_ONLY;
    if (!userModule.isDokter) return "Order emergensi dibuat dan ditandatangani oleh dokter. Anda dapat melihat daftar dan mencetak order.";
    return null;
  }

  mounted() {
    storeOrderEmergensi.muatPaket();
    this.muatUlang();
  }

  @Watch("register")
  onRegisterChange() {
    this.tutupForm();
    this.muatUlang();
  }

  @Watch("focusOrderId", { immediate: true })
  onFocusOrder(id: number | null) {
    if (!id) return;
    this.fokusTertunda = Number(id);
    this.bukaFokus();
  }

  @Watch("list")
  onListChange() {
    this.bukaFokus();
  }

  bukaFokus() {
    if (!this.fokusTertunda) return;
    const order = this.list.find(o => Number(o.id) === this.fokusTertunda);
    if (order) {
      this.fokusTertunda = null;
      this.lihat(order);
    }
  }

  muatUlang() {
    if (!this.register) return;
    storeOrderEmergensi.muatDaftar(this.register);
  }

  statusInfo(item: OrderEmergensi) {
    return STATUS_ORDER_EMERGENSI[item.status] || { label: item.status, color: "grey" };
  }

  formatWaktu(nilai: string | null): string {
    return nilai ? moment(nilai, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  bukanPembuat(item: OrderEmergensi): boolean {
    return !item.dokter || Number(item.dokter.id) !== Number(userModule.user.id);
  }

  sudahDiproses(item: OrderEmergensi): boolean {
    return item.status !== "dikirim" || (!!item.resep && item.resep.status > 1);
  }

  alasanUbah(item: OrderEmergensi): string | null {
    if (this.readOnly) return ALASAN_READ_ONLY;
    if (item.status === "batal") return "Order sudah dibatalkan";
    if (this.bukanPembuat(item)) return "Hanya dokter pembuat order yang dapat mengubah";
    if (this.sudahDiproses(item)) return "Sudah diproses Instalasi Farmasi — gunakan Retur Obat untuk obat yang tidak terpakai";
    if (item.signed) return "Sudah ditandatangani — batalkan lalu buat order baru bila perlu";
    return null;
  }

  alasanTtd(item: OrderEmergensi): string | null {
    if (this.readOnly) return ALASAN_READ_ONLY;
    if (item.status === "batal") return "Order sudah dibatalkan";
    if (item.signed) return "Sudah ditandatangani";
    if (this.bukanPembuat(item)) return "Hanya dokter pembuat order yang dapat menandatangani";
    return null;
  }

  alasanBatal(item: OrderEmergensi): string | null {
    if (this.readOnly) return ALASAN_READ_ONLY;
    if (item.status === "batal") return "Order sudah dibatalkan";
    if (this.bukanPembuat(item)) return "Hanya dokter pembuat order yang dapat membatalkan";
    if (this.sudahDiproses(item)) return "Sudah diproses Instalasi Farmasi sehingga tidak dapat dibatalkan";
    return null;
  }

  bukaForm(paket: PaketObatEmergensi | null, order: OrderEmergensi | null, lihat: boolean) {
    this.paketDipilih = paket;
    this.orderDipilih = order;
    this.modeLihat = lihat;
    this.formKey++;
    this.formTerbuka = true;
  }

  buatDariPaket(paket: PaketObatEmergensi | null) {
    if (this.alasanTidakBisaOrder) return;
    this.bukaForm(paket, null, false);
  }

  lihat(item: OrderEmergensi) {
    this.bukaForm(null, item, true);
  }

  ubah(item: OrderEmergensi) {
    if (this.alasanUbah(item)) return;
    this.bukaForm(null, item, false);
  }

  tutupForm() {
    this.formTerbuka = false;
    this.paketDipilih = null;
    this.orderDipilih = null;
    this.modeLihat = false;
  }

  onSaved(order: OrderEmergensi) {
    if (order) storeOrderEmergensi.UPSERT(order);
    this.tutupForm();
    this.muatUlang();
    this.$emit("berubah");
  }

  cetak(item: OrderEmergensi) {
    OrderEmergensiSvc.print(item.id);
  }

  bukaBatal(item: OrderEmergensi) {
    if (this.alasanBatal(item)) return;
    this.orderAksi = item;
    this.alasanBatalInput = "";
    this.dialogBatal = true;
  }

  async doBatal() {
    if (!this.orderAksi || this.membatalkan) return;
    this.membatalkan = true;
    try {
      const resp = await OrderEmergensiSvc.batal(this.orderAksi.id, this.alasanBatalInput.trim());
      storeOrderEmergensi.UPSERT(resp.data.data);
      this.$emit("berubah");
      appModule.NoticeDelay("Order emergensi dibatalkan");
      this.dialogBatal = false;
      this.orderAksi = null;
    } catch {
      this.muatUlang();
    } finally {
      this.membatalkan = false;
    }
  }

  bukaTtd(item: OrderEmergensi) {
    if (this.alasanTtd(item)) return;
    this.orderAksi = item;
    this.dialogTtd = true;
  }

  async doTtd(password: string) {
    if (!this.orderAksi || this.menandatangani) return;
    this.menandatangani = true;
    try {
      await OrderEmergensiSvc.sign(this.orderAksi.id, password);
      appModule.NoticeDelay("Order emergensi berhasil ditandatangani");
      this.dialogTtd = false;
      this.orderAksi = null;
      this.muatUlang();
    } catch {
      return;
    } finally {
      this.menandatangani = false;
    }
  }
}
